import {useContext, useEffect, useState} from "react";
import {ModalContext} from "../../../utils/modal/ModalProvider";
import styles from "./PageDetailModal.module.css";
import {IAM_SERVER_SERVICE_PAGE} from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import { InnocodeButton, InnocodeInput, useDialog, useInnocodeLoadingOverlay } from "@intsoft/innocode-core";



/**
 * 사용자 상세정보 모달 Container
 * @param id
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
export const PageDetailModal = ({id, update, pageNameMap}) => {
    const {closeModal} = useContext(ModalContext);
    const { showDialog } = useDialog();
    const { show: showLoading, hide: hideLoading } = useInnocodeLoadingOverlay();

    const [formData, setFormData] = useState({
        pageId: '',
        linkServiceId: '',
        pageName: '',
        pageUrl: '',
        parentPageId: '',
        parentPageName:''
    });

    useEffect(() => {
        const fetchPageData = async () => {
            showLoading();
            try {
                // 1. 페이지 정보 조회
                const url = `${IAM_SERVER_SERVICE_PAGE}/get/${id}`;
                const res = await axios.get(url);
                const data = res.data.data;

                let parentPageName = '';
                // 2. 부모 페이지 있으면 추가 조회
                if (data.parentPageId !== null && data.parentPageId !== '') {
                    try {
                        const parentUrl = `${IAM_SERVER_SERVICE_PAGE}/get/${data.parentPageId}`;
                        const parentRes = await axios.get(parentUrl);
                        parentPageName = parentRes.data.data.pageName || '';
                    } catch (parentErr) {
                        // 부모 페이지 정보가 없어도 에러만 콘솔에 기록하고 진행
                        console.warn('부모 페이지 조회 실패:', parentErr);
                    }
                }

                // 3. 폼 데이터 세팅
                setFormData({
                    pageId: data.pageId || '',
                    linkServiceId: data.linkServiceId || '',
                    pageName: data.pageName || '',
                    pageUrl: data.pageUrl || '',
                    parentPageId: data.parentPageId || '',
                    parentPageName: parentPageName
                });
            } catch (e) {
                showDialog({
                    iconType: "warning",
                    type: 'error',
                    title: "실패",
                    message: "페이지 정보 조회에 실패했습니다.",
                    confirmText: "확인",
                });
            } finally {
                hideLoading();
            }
        };

        fetchPageData();
    }, [id, showDialog, showLoading, hideLoading]);

    return (
        <div style={{overflow: "auto"}}>
            <ul className={styles.layer__listWrap}>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>페이지 명</p>
                    <InnocodeInput
                        name="pageName"
                        value={formData.pageName}
                        disabled={true}
                        placeholder="페이지 명"
                    />
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>페이지 URL</p>
                    <InnocodeInput
                        name="pageUrl"
                        value={formData.pageUrl}
                        disabled={true}
                        placeholder="페이지 URL"
                    />
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>상위페이지</p>
                    <InnocodeInput
                        name="parentPageName"
                        value={formData.parentPageName}
                        disabled={true}
                        placeholder="상위페이지"
                    />
                </li>
            </ul> 
            <div className={styles.layer__sensorBtnBox}>
                <InnocodeButton
                    size="lg"
                    theme="solid"
                    fullWidth={true}
                    designType="assistive"
                    onClick={closeModal}
                >
                    닫기
                </InnocodeButton>
            </div>
        </div>
    );
}